export default from './Translate';

export Translate from './Translate';
export getInstance from './getInstance';

export Plural from './constants/Plural';
export Gender from './constants/Gender';
export Mode from './constants/Mode';

export Adapter from './adapters/Adapter';
export FileAdapter from './adapters/File';
export MemoryAdapter from './adapters/Memory';
export XHRAdapter from './adapters/XHR';

export Cache from './caches/Cache';
export DummyCache from './caches/Dummy';
export MemoryCache from './caches/Memory';
